/** Shared shell for every media tile and placeholder, so the video, the
 *  screenshot, and the two empty states all sit in an identical box.
 *
 *  The shadow is what stops the figure reading as a flat diagram — it is the
 *  main source of depth on the page. */
export const FRAME =
  "relative w-full overflow-hidden rounded-2xl bg-surface shadow-soft ring-1 ring-line";
